// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Form, Button, Card, Row, Col, Alert } from "react-bootstrap";
// import { membershipAPI } from "../../api/membershipPlans";
// import { gymMembersAPI } from "../../api/gymMembers";
// import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
// import { FaUser, FaCalendar, FaDollarSign, FaArrowLeft } from "react-icons/fa";

// const AddPlan = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [members, setMembers] = useState([]);
//   const [subscriptionTypes, setSubscriptionTypes] = useState([
//     { id: 1, name: "Basic" },
//     { id: 2, name: "Premium" },
//     { id: 3, name: "Gold" },
//   ]);
//   const [subscriptionPeriods, setSubscriptionPeriods] = useState([
//     { id: 1, months: 1, name: "1 Month" },
//     { id: 2, months: 3, name: "3 Months" },
//     { id: 3, months: 6, name: "6 Months" },
//     { id: 4, months: 12, name: "12 Months" },
//   ]);

//   const [formData, setFormData] = useState({
//     member: "",
//     subscription_type: "",
//     subscription_period: "",
//     batch: "morning",
//     plan_start_date: new Date(),
//     registration_fee: "500",
//     amount: "",
//     paid_amount: "0",
//     notes: "",
//   });

//   const [calculatedEndDate, setCalculatedEndDate] = useState(null);
//   const [calculatedTotal, setCalculatedTotal] = useState(0);
//   const [calculatedPending, setCalculatedPending] = useState(0);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     calculateEndDate();
//     calculateAmounts();
//   }, [
//     formData.plan_start_date,
//     formData.subscription_period,
//     formData.registration_fee,
//     formData.amount,
//     formData.paid_amount,
//   ]);

//   const fetchData = async () => {
//     try {
//       const membersResponse = await gymMembersAPI.getMembers();
//       setMembers(membersResponse.data.data || membersResponse.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load members data",
//       });
//     }
//   };

//   const calculateEndDate = () => {
//     if (!formData.plan_start_date || !formData.subscription_period) {
//       setCalculatedEndDate(null);
//       return;
//     }

//     const selectedPeriod = subscriptionPeriods.find(
//       (period) => period.id === parseInt(formData.subscription_period)
//     );

//     if (!selectedPeriod) return;

//     const startDate = new Date(formData.plan_start_date);
//     const endDate = new Date(startDate);
//     endDate.setMonth(endDate.getMonth() + selectedPeriod.months);
//     setCalculatedEndDate(endDate);
//   };

//   const calculateAmounts = () => {
//     const registrationFee = parseFloat(formData.registration_fee) || 0;
//     const amount = parseFloat(formData.amount) || 0;
//     const paidAmount = parseFloat(formData.paid_amount) || 0;

//     setCalculatedTotal(registrationFee + amount);
//     setCalculatedPending(registrationFee + amount - paidAmount);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleDateChange = (date) => {
//     setFormData({
//       ...formData,
//       plan_start_date: date,
//     });
//   };

//   const validateForm = () => {
//     const errors = [];

//     if (!formData.member) errors.push("Please select a member");
//     if (!formData.subscription_type)
//       errors.push("Please select subscription type");
//     if (!formData.subscription_period)
//       errors.push("Please select subscription period");
//     if (!formData.plan_start_date) errors.push("Please select start date");
//     if (!formData.amount || formData.amount <= 0)
//       errors.push("Please enter valid amount");
//     if (
//       parseFloat(formData.paid_amount) >
//       parseFloat(formData.amount) + parseFloat(formData.registration_fee)
//     ) {
//       errors.push("Paid amount cannot exceed total amount");
//     }

//     return errors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const errors = validateForm();
//     if (errors.length > 0) {
//       Swal.fire({
//         icon: "error",
//         title: "Validation Error",
//         html: errors.map((err) => `<p>• ${err}</p>`).join(""),
//       });
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const planData = {
//         member: parseInt(formData.member),
//         subscription_type: parseInt(formData.subscription_type),
//         subscription_period: parseInt(formData.subscription_period),
//         batch: formData.batch,
//         plan_start_date: formData.plan_start_date.toISOString().split("T")[0],
//         registration_fee: parseFloat(formData.registration_fee) || 0,
//         amount: parseFloat(formData.amount),
//         paid_amount: parseFloat(formData.paid_amount) || 0,
//       };

//       const response = await membershipAPI.createPlan(planData);

//       Swal.fire({
//         icon: "success",
//         title: "Plan Created!",
//         html: `
//           <div>
//             <p>Membership plan has been created successfully.</p>
//             <p><strong>Plan ID:</strong> ${response.data.data.id}</p>
//             <p><strong>Total Amount:</strong> ₹${response.data.data.total_amount}</p>
//             <p><strong>Pending Amount:</strong> ₹${response.data.data.pending_amount}</p>
//           </div>
//         `,
//         timer: 2000,
//         showConfirmButton: false,
//       });

//       setTimeout(() => {
//         navigate("/membership/plans");
//       }, 2000);
//     } catch (error) {
//       console.error("Error creating plan:", error);
//       setError(
//         error.response?.data?.message || "Failed to create membership plan"
//       );
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text:
//           error.response?.data?.message || "Failed to create membership plan",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getMemberName = (memberId) => {
//     const member = members.find((m) => m.id === parseInt(memberId));
//     return member
//       ? `${member.first_name} ${member.last_name} (${member.member_id})`
//       : "Select Member";
//   };

//   return (
//     <div className="add-plan-page">
//       <div className="page-header mb-4">
//         <Button
//           variant="outline-secondary"
//           onClick={() => navigate("/membership/plans")}
//           className="me-3"
//         >
//           <FaArrowLeft /> Back to Plans
//         </Button>
//         <h2 className="mb-0">Create Membership Plan</h2>
//       </div>

//       {error && (
//         <Alert variant="danger" onClose={() => setError("")} dismissible>
//           {error}
//         </Alert>
//       )}

//       <Row>
//         <Col lg={8}>
//           <Card className="mb-4">
//             <Card.Header className="bg-primary text-white">
//               <h5 className="mb-0">Plan Details</h5>
//             </Card.Header>
//             <Card.Body>
//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Select Member *</Form.Label>
//                       <Form.Select
//                         name="member"
//                         value={formData.member}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select Member</option>
//                         {members.map((member) => (
//                           <option key={member.id} value={member.id}>
//                             {member.first_name} {member.last_name} (
//                             {member.member_id})
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Subscription Type *</Form.Label>
//                       <Form.Select
//                         name="subscription_type"
//                         value={formData.subscription_type}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select Type</option>
//                         {subscriptionTypes.map((type) => (
//                           <option key={type.id} value={type.id}>
//                             {type.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Subscription Period *</Form.Label>
//                       <Form.Select
//                         name="subscription_period"
//                         value={formData.subscription_period}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select Period</option>
//                         {subscriptionPeriods.map((period) => (
//                           <option key={period.id} value={period.id}>
//                             {period.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Batch *</Form.Label>
//                       <Form.Select
//                         name="batch"
//                         value={formData.batch}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="morning">Morning</option>
//                         <option value="evening">Evening</option>
//                         <option value="full_day">Full Day</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Plan Start Date *</Form.Label>
//                       <DatePicker
//                         selected={formData.plan_start_date}
//                         onChange={handleDateChange}
//                         dateFormat="yyyy-MM-dd"
//                         className="form-control"
//                         placeholderText="Select start date"
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Registration Fee (₹)</Form.Label>
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <FaDollarSign />
//                         </span>
//                         <Form.Control
//                           type="number"
//                           name="registration_fee"
//                           value={formData.registration_fee}
//                           onChange={handleChange}
//                           placeholder="500"
//                           min="0"
//                           step="0.01"
//                         />
//                       </div>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Total Amount (₹) *</Form.Label>
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <FaDollarSign />
//                         </span>
//                         <Form.Control
//                           type="number"
//                           name="amount"
//                           value={formData.amount}
//                           onChange={handleChange}
//                           placeholder="3000"
//                           min="1"
//                           step="0.01"
//                           required
//                         />
//                       </div>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Paid Amount (₹)</Form.Label>
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <FaDollarSign />
//                         </span>
//                         <Form.Control
//                           type="number"
//                           name="paid_amount"
//                           value={formData.paid_amount}
//                           onChange={handleChange}
//                           placeholder="0"
//                           min="0"
//                           step="0.01"
//                         />
//                       </div>
//                       <Form.Text className="text-muted">
//                         Leave as 0 if payment is pending
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-4">
//                   <Form.Label>Notes (Optional)</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     name="notes"
//                     value={formData.notes}
//                     onChange={handleChange}
//                     placeholder="Any additional notes or terms..."
//                   />
//                 </Form.Group>

//                 <div className="text-center">
//                   <Button
//                     variant="primary"
//                     type="submit"
//                     disabled={loading}
//                     className="px-5"
//                   >
//                     {loading ? "Creating Plan..." : "Create Membership Plan"}
//                   </Button>
//                 </div>
//               </Form>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col lg={4}>
//           <Card className="mb-4">
//             <Card.Header className="bg-info text-white">
//               <h5 className="mb-0">Plan Summary</h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="plan-summary">
//                 {formData.member && (
//                   <div className="mb-3">
//                     <h6>Selected Member:</h6>
//                     <p className="fw-bold">{getMemberName(formData.member)}</p>
//                   </div>
//                 )}

//                 {formData.subscription_type && (
//                   <div className="mb-3">
//                     <h6>Subscription Type:</h6>
//                     <p className="fw-bold">
//                       {subscriptionTypes.find(
//                         (t) => t.id === parseInt(formData.subscription_type)
//                       )?.name || "N/A"}
//                     </p>
//                   </div>
//                 )}

//                 {formData.subscription_period && (
//                   <div className="mb-3">
//                     <h6>Duration:</h6>
//                     <p className="fw-bold">
//                       {subscriptionPeriods.find(
//                         (p) => p.id === parseInt(formData.subscription_period)
//                       )?.name || "N/A"}
//                     </p>
//                   </div>
//                 )}

//                 <div className="mb-3">
//                   <h6>Batch:</h6>
//                   <p className="fw-bold">
//                     {formData.batch
//                       ? formData.batch.charAt(0).toUpperCase() +
//                         formData.batch.slice(1)
//                       : "Not set"}
//                   </p>
//                 </div>

//                 <div className="mb-3">
//                   <h6>Start Date:</h6>
//                   <p className="fw-bold">
//                     {formData.plan_start_date
//                       ? formData.plan_start_date.toLocaleDateString()
//                       : "Not set"}
//                   </p>
//                 </div>

//                 <div className="mb-3">
//                   <h6>Estimated End Date:</h6>
//                   <p className="fw-bold">
//                     {calculatedEndDate
//                       ? calculatedEndDate.toLocaleDateString()
//                       : "Calculate by selecting period"}
//                   </p>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>

//           <Card>
//             <Card.Header className="bg-success text-white">
//               <h5 className="mb-0">Payment Summary</h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="payment-summary">
//                 <table className="table table-sm">
//                   <tbody>
//                     <tr>
//                       <td>Registration Fee:</td>
//                       <td className="text-end">
//                         ₹{formData.registration_fee || "0"}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Plan Amount:</td>
//                       <td className="text-end">₹{formData.amount || "0"}</td>
//                     </tr>
//                     <tr className="table-active fw-bold">
//                       <td>Total Amount:</td>
//                       <td className="text-end">
//                         ₹{calculatedTotal.toFixed(2)}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Paid Amount:</td>
//                       <td className="text-end text-success">
//                         ₹{formData.paid_amount || "0"}
//                       </td>
//                     </tr>
//                     <tr className="table-warning fw-bold">
//                       <td>Pending Amount:</td>
//                       <td className="text-end text-danger">
//                         ₹{calculatedPending.toFixed(2)}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Fee Status:</td>
//                       <td className="text-end">
//                         <span
//                           className={`badge ${
//                             calculatedPending > 0 ? "bg-warning" : "bg-success"
//                           }`}
//                         >
//                           {calculatedPending > 0 ? "Pending" : "Paid"}
//                         </span>
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default AddPlan;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Card, Row, Col, Alert, Spinner } from "react-bootstrap";
import { membershipAPI } from "../../api/membershipPlans";
import { gymMembersAPI } from "../../api/gymMembers";
import { subscriptionAPI } from "../../api/subscription";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import { FaUser, FaCalendar, FaDollarSign, FaArrowLeft } from "react-icons/fa";

const AddPlan = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [error, setError] = useState("");
  const [members, setMembers] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [subscriptionPeriods, setSubscriptionPeriods] = useState([]);

  const [formData, setFormData] = useState({
    member: "",
    subscription_type: "",
    subscription_period: "",
    batch: "morning",
    plan_start_date: new Date(),
    registration_fee: "0",
    amount: "",
    paid_amount: "0",
    notes: "",
  });

  const [calculatedEndDate, setCalculatedEndDate] = useState(null);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [calculatedPending, setCalculatedPending] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    calculateEndDate();
    calculateAmounts();
  }, [
    formData.plan_start_date,
    formData.subscription_period,
    formData.registration_fee,
    formData.amount,
    formData.paid_amount,
  ]);

  const fetchData = async () => {
    try {
      const [membersResponse, typesResponse, periodsResponse] =
        await Promise.all([
          gymMembersAPI.getMembers(),
          subscriptionAPI.getSubscriptionTypes(),
          subscriptionAPI.getSubscriptionPeriods(),
        ]);

      setMembers(membersResponse.data.data || membersResponse.data);
      setSubscriptionTypes(typesResponse.data || []);
      setSubscriptionPeriods(periodsResponse.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load data",
      });
    } finally {
      setFetchingData(false);
    }
  };

  const calculateEndDate = () => {
    if (!formData.plan_start_date || !formData.subscription_period) {
      setCalculatedEndDate(null);
      return;
    }

    const selectedPeriod = subscriptionPeriods.find(
      (period) => period.id === parseInt(formData.subscription_period)
    );

    if (!selectedPeriod) return;

    const startDate = new Date(formData.plan_start_date);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + selectedPeriod.months);
    setCalculatedEndDate(endDate);
  };

  const calculateAmounts = () => {
    const registrationFee = parseFloat(formData.registration_fee) || 0;
    const amount = parseFloat(formData.amount) || 0;
    const paidAmount = parseFloat(formData.paid_amount) || 0;

    setCalculatedTotal(registrationFee + amount);
    setCalculatedPending(registrationFee + amount - paidAmount);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      plan_start_date: date,
    });
  };

  const validateForm = () => {
    const errors = [];

    if (!formData.member) errors.push("Please select a member");
    if (!formData.subscription_type)
      errors.push("Please select subscription type");
    if (!formData.subscription_period)
      errors.push("Please select subscription period");
    if (!formData.plan_start_date) errors.push("Please select start date");
    if (!formData.amount || formData.amount <= 0)
      errors.push("Please enter valid amount");
    if (
      parseFloat(formData.paid_amount) >
      parseFloat(formData.amount) + parseFloat(formData.registration_fee)
    ) {
      errors.push("Paid amount cannot exceed total amount");
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (errors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: errors.map((err) => `<p>• ${err}</p>`).join(""),
      });
      return;
    }

    setLoading(true);
    setError("");

    try {
      const planData = {
        member: parseInt(formData.member),
        subscription_type: parseInt(formData.subscription_type),
        subscription_period: parseInt(formData.subscription_period),
        batch: formData.batch,
        plan_start_date: formData.plan_start_date.toISOString().split("T")[0],
        registration_fee: parseFloat(formData.registration_fee) || 0,
        amount: parseFloat(formData.amount),
        paid_amount: parseFloat(formData.paid_amount) || 0,
      };

      const response = await membershipAPI.createPlan(planData);

      Swal.fire({
        icon: "success",
        title: "Plan Created!",
        html: `
          <div>
            <p>Membership plan has been created successfully.</p>
            <p><strong>Plan ID:</strong> ${response.data.data.id}</p>
            <p><strong>Total Amount:</strong> ₹${response.data.data.total_amount}</p>
            <p><strong>Pending Amount:</strong> ₹${response.data.data.pending_amount}</p>
          </div>
        `,
        timer: 2000,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/membership/plans");
      }, 2000);
    } catch (error) {
      console.error("Error creating plan:", error);
      setError(
        error.response?.data?.message || "Failed to create membership plan"
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message || "Failed to create membership plan",
      });
    } finally {
      setLoading(false);
    }
  };

  const getMemberName = (memberId) => {
    const member = members.find((m) => m.id === parseInt(memberId));
    return member
      ? `${member.first_name} ${member.last_name} (${member.member_id})`
      : "Select Member";
  };

  const getSubscriptionTypeName = (typeId) => {
    const type = subscriptionTypes.find((t) => t.id === parseInt(typeId));
    return type ? type.name : "Select Type";
  };

  const getSubscriptionPeriodName = (periodId) => {
    const period = subscriptionPeriods.find((p) => p.id === parseInt(periodId));
    return period
      ? `${period.months} Month${period.months !== 1 ? "s" : ""}`
      : "Select Period";
  };

  if (fetchingData) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading data...</p>
      </div>
    );
  }

  return (
    <div className="add-plan-page">
      <div className="page-header mb-4">
        <Button
          variant="outline-secondary"
          onClick={() => navigate("/membership/plans")}
          className="me-3"
        >
          <FaArrowLeft /> Back to Plans
        </Button>
        <h2 className="mb-0">Create Membership Plan</h2>
      </div>

      {error && (
        <Alert variant="danger" onClose={() => setError("")} dismissible>
          {error}
        </Alert>
      )}

      <Row>
        <Col lg={8}>
          <Card className="mb-4">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Plan Details</h5>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Select Member *</Form.Label>
                      <Form.Select
                        name="member"
                        value={formData.member}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Member</option>
                        {members.map((member) => (
                          <option key={member.id} value={member.id}>
                            {member.first_name} {member.last_name} (
                            {member.member_id})
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subscription Type *</Form.Label>
                      <Form.Select
                        name="subscription_type"
                        value={formData.subscription_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Type</option>
                        {subscriptionTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subscription Period *</Form.Label>
                      <Form.Select
                        name="subscription_period"
                        value={formData.subscription_period}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Period</option>
                        {subscriptionPeriods.map((period) => (
                          <option key={period.id} value={period.id}>
                            {period.months} Month
                            {period.months !== 1 ? "s" : ""}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Batch *</Form.Label>
                      <Form.Select
                        name="batch"
                        value={formData.batch}
                        onChange={handleChange}
                        required
                      >
                        <option value="morning">Morning</option>
                        <option value="evening">Evening</option>

                        <option value="early_morning">Early Morning</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Plan Start Date *</Form.Label>
                      <DatePicker
                        selected={formData.plan_start_date}
                        onChange={handleDateChange}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        placeholderText="Select start date"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Registration Fee (₹)</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaDollarSign />
                        </span>
                        <Form.Control
                          type="number"
                          name="registration_fee"
                          value={formData.registration_fee}
                          onChange={handleChange}
                          placeholder="500"
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label> Amount (₹) *</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaDollarSign />
                        </span>
                        <Form.Control
                          type="number"
                          name="amount"
                          value={formData.amount}
                          onChange={handleChange}
                          placeholder="3000"
                          min="1"
                          step="0.01"
                          required
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Paid Amount (₹)</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaDollarSign />
                        </span>
                        <Form.Control
                          type="number"
                          name="paid_amount"
                          value={formData.paid_amount}
                          onChange={handleChange}
                          placeholder="0"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      <Form.Text className="text-muted">
                        Leave as 0 if payment is pending
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-4">
                  <Form.Label>Notes (Optional)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    placeholder="Any additional notes or terms..."
                  />
                </Form.Group>

                <div className="text-center">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={loading}
                    className="px-5"
                  >
                    {loading ? "Creating Plan..." : "Create Membership Plan"}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4}>
          <Card className="mb-4">
            <Card.Header className="bg-info text-white">
              <h5 className="mb-0">Plan Summary</h5>
            </Card.Header>
            <Card.Body>
              <div className="plan-summary">
                {formData.member && (
                  <div className="mb-3">
                    <h6>Selected Member:</h6>
                    <p className="fw-bold">{getMemberName(formData.member)}</p>
                  </div>
                )}

                {formData.subscription_type && (
                  <div className="mb-3">
                    <h6>Subscription Type:</h6>
                    <p className="fw-bold">
                      {getSubscriptionTypeName(formData.subscription_type)}
                    </p>
                  </div>
                )}

                {formData.subscription_period && (
                  <div className="mb-3">
                    <h6>Duration:</h6>
                    <p className="fw-bold">
                      {getSubscriptionPeriodName(formData.subscription_period)}
                    </p>
                  </div>
                )}

                <div className="mb-3">
                  <h6>Batch:</h6>
                  <p className="fw-bold">
                    {formData.batch
                      ? formData.batch.charAt(0).toUpperCase() +
                        formData.batch.slice(1)
                      : "Not set"}
                  </p>
                </div>

                <div className="mb-3">
                  <h6>Start Date:</h6>
                  <p className="fw-bold">
                    {formData.plan_start_date
                      ? formData.plan_start_date.toLocaleDateString()
                      : "Not set"}
                  </p>
                </div>

                <div className="mb-3">
                  <h6>Estimated End Date:</h6>
                  <p className="fw-bold">
                    {calculatedEndDate
                      ? calculatedEndDate.toLocaleDateString()
                      : "Calculate by selecting period"}
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header className="bg-success text-white">
              <h5 className="mb-0">Payment Summary</h5>
            </Card.Header>
            <Card.Body>
              <div className="payment-summary">
                <table className="table table-sm">
                  <tbody>
                    <tr>
                      <td>Registration Fee:</td>
                      <td className="text-end">
                        ₹{formData.registration_fee || "0"}
                      </td>
                    </tr>
                    <tr>
                      <td>Plan Amount:</td>
                      <td className="text-end">₹{formData.amount || "0"}</td>
                    </tr>
                    <tr className="table-active fw-bold">
                      <td>Total Amount:</td>
                      <td className="text-end">
                        ₹{calculatedTotal.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>Paid Amount:</td>
                      <td className="text-end text-success">
                        ₹{formData.paid_amount || "0"}
                      </td>
                    </tr>
                    <tr className="table-warning fw-bold">
                      <td>Pending Amount:</td>
                      <td className="text-end text-danger">
                        ₹{calculatedPending.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>Fee Status:</td>
                      <td className="text-end">
                        <span
                          className={`badge ${
                            calculatedPending > 0 ? "bg-warning" : "bg-success"
                          }`}
                        >
                          {calculatedPending > 0 ? "Pending" : "Paid"}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddPlan;
